import { useQuery } from 'react-query';

import { getAllTags as queryFn } from 'api/endPoints/getAllTags';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetReportsTags = () => {
    return useQuery<QueryResponse[], QueryError, QueryResponse[], [QueryKeys]>({
        queryKey: ['getAllReportTags'],
        queryFn: () => queryFn(),
    });
};

export interface QueryResponse {
    id: number;
    name: string;
}
